import api from "@/apis/EmployeeAPI";
import Crud from "./crud-base";
import httpClient from "@/apis/base/axios-httpclient";
var crud = new Crud("Employee", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "EmployeeID",
      code: "EmployeeCode",
      name: "FullName",
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Đồng bộ NV
   * @returns danh sách nv được đồng bộ
   */
  syncEmployeeFromAMIS: async function () {
    let request = {
      url: [api.getAPIUrl(), "sync_employee"].join("/"),
    };
    return await httpClient.getAsync(request);
  },
  /**
   * Đồng bộ CCTC
   * @returns Danh sách CCTC được đồng bộ về
   */
  syncOrganizationFromAMIS: async function () {
    let request = {
      url: [api.getAPIUrl(), "sync_organization"].join("/"),
    };
    return await httpClient.getAsync(request);
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
